import { render } from "./AskForResetPassword.vue?vue&type=template&id=784d6edb&scoped=true"
import script from "./AskForResetPassword.vue?vue&type=script&lang=js"
export * from "./AskForResetPassword.vue?vue&type=script&lang=js"

import "./AskForResetPassword.vue?vue&type=style&index=0&id=784d6edb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784d6edb"]])

export default __exports__